import { useEffect, useMemo, useState } from "react"

import { XIcon } from "lucide-react"
import { Input, DefaultPopover, Separator, ToggleOptionGroup, ToggleOptionGroupItem } from "twyne-new.ui"

import { useResponsive, useUtilities } from "@/modules/cms/views/post/components/builder/context"

import { useCraftProp } from "../../utils"
import ApplyButtonPopover from "../components/ApplyButtonPopover"

import Advanced from "./Advanced"
import General from "./General"

export default function MaskPropertyWrapper() {
  const { device } = useResponsive()
  const { selectedUtilities } = useUtilities()

  return <>
    <MaskProperty key={device + selectedUtilities} />
  </>
}

const MaskProperty = () => {
  const [open, setOpen] = useState(false)
  const [mask, setMask] = useState()
  const [tab, setTab] = useState('general')

  const { value: craftValue, setValue: setCraftValue } = useCraftProp('mask')

  useEffect(() => {
    if (!open) {
      return setMask(undefined)
    }

    if (mask === undefined) {
      setMask(craftValue || {})
    }
  }, [mask, craftValue, open, setMask])

  const handleApply = () => {
    setCraftValue(mask)
  }

  const handleCancel = () => {
    setMask()
    setOpen(false)
  }

  const handleChange = value => {
    setMask(prev => ({ ...prev, ...value }))
  }

  return <>
    <InputTrigger onClick={() => setOpen(true)} value={craftValue} />
    <DefaultPopover
      wrapperProps={{ open, onOpenChange: setOpen }}
      trigger={<div></div>}
      triggerProps={{ asChild: true }}
      contentProps={{ className: 'w-96', side: 'left', align: 'center' }}
    >
      <div className="w-full">
        <div className='flex justify-between items-center'>
          Mask

          <XIcon size='16' className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <Separator className='m-0 my-2' />

        <ToggleOptionGroup className='mb-4' type='single' value={tab} onValueChange={setTab}>
          <ToggleOptionGroupItem value='general'>General</ToggleOptionGroupItem>
          <ToggleOptionGroupItem value='advanced'>Advanced</ToggleOptionGroupItem>
        </ToggleOptionGroup>

        {tab === 'advanced' && <Advanced values={mask} onChange={handleChange} />}
        {tab === 'general' && <General properties={mask?.properties} onChange={handleChange} />}
      </div>

      <ApplyButtonPopover
        onApply={handleApply}
        onCancel={handleCancel}
        name='mask'
        value={mask}
      />
    </DefaultPopover>
  </>
}

const InputTrigger = ({ onClick, value = {} }) => {
  const inputValue = useMemo(() => [
    value?.properties?.image?.src && `image`,
    value?.properties?.gradient?.colors?.length > 0 && `gradient`,
    value?.behavior && `behavior: ${value.behavior}`,
    value?.snap?.align && `snap-align: ${value.snap.align}`,
    value?.snap?.stop && `snap-stop: ${value.snap.stop}`,
    value?.snap?.type && `snap-type: ${value.snap.type}`,
  ].filter(Boolean).join(', '), [value])

  return <Input value={inputValue} readOnly variant='accent' onClick={onClick} />
}
